!(function () {
  "use strict";

  const e = document.querySelector(".product-configurator");

  if (e) {
    const t = document.querySelector(".product-popup-modal--material");

    let o = "",
      r = "",
      n = 0,
      a = window.shopUrl + e.dataset.url,
      D = "";

    function getVal(inputElement) {
      if (!inputElement) return "";
      return inputElement.dataset.techName || inputElement.value;
    }

    function findInput(name, value) {
      if (!value) return null;

      if (name) {
        return (
          e.querySelector(`input[name="${name}"][data-tech-name="${value}"]`) ||
          e.querySelector(`input[name="${name}"][value="${value}"]`)
        );
      }

      return (
        e.querySelector(`input[data-tech-name="${value}"]`) ||
        e.querySelector(`input[value="${value}"]`)
      );
    }

    function setRadioChecked(input) {
      if (!input) return false;

      e.querySelectorAll("input").forEach((otherInput) => {
        if (otherInput.name === input.name) {
          otherInput.checked = false;
          otherInput.removeAttribute("checked");
        }
      });

      input.checked = true;
      input.setAttribute("checked", "checked");

      return true;
    }

    function getInputNameText(input) {
      if (!input) return "";

      return (
        input.nextElementSibling?.querySelector(".name")?.textContent?.trim() ||
        input.dataset.techName ||
        input.value ||
        ""
      );
    }

    function Q() {
      const t = new URLSearchParams(window.location.search),
        n = e.querySelector(".product-configurator__accordion > div");

      n && n.setAttribute("open", "");

      for (const [paramName, paramValue] of t.entries()) {
        if (paramName === "layout") {
          o = paramValue;
        }

        if (paramName === "open-config") {
          t.delete("open-config");
          document.querySelector(".button--configurator")?.click();
        }
      }

      for (const [paramName, paramValue] of t.entries()) {
        const a = e.querySelector(
          `.product-configurator__accordion--attr[data-type="${paramName}"]`,
        );

        const c = findInput(paramName, paramValue);

        const i = e.querySelector(
          `.form__label[data-name=${paramName}] .selected`,
        );

        if (a) {
          a.setAttribute("from-params", "");
        }

        if (c) {
          setRadioChecked(c);

          const realValue = getVal(c);
          const nameText = getInputNameText(c);

          if (i) {
            i.textContent = nameText;
          }

          if (paramName === "material") {
            m(nameText, true);
            f(c);
            H(realValue);
          }

          if (paramName === "color") {
            r = realValue;
            S(realValue);
          }

          if (paramName === "layout") {
            o = realValue;
            S(r);
          }

          if (paramName === "dimension") {
            D = realValue ? `-${realValue}` : "";
            S(r);
          }

          Z(c.name);
          v(c.name, realValue);
        }
      }

      const a = e.querySelectorAll(
        ".product-configurator__accordion--attr:not([from-params])",
      );

      if (a.length) {
        a.forEach((accordion) => {
          const firstInput = accordion.querySelector("input");
          let val = firstInput ? getVal(firstInput) : "";

          if (firstInput && firstInput.name === "layout") {
            o = val;
          }
        });

        a.forEach((accordion) => {
          const input = accordion.querySelector("input");

          if (input) {
            const isAutoMaterialOrColor =
              ["material", "color"].includes(input.name) &&
              !t.has(input.name);

            if (isAutoMaterialOrColor) {
              return;
            }

            setRadioChecked(input);

            let val = getVal(input);
            let nameText = getInputNameText(input);

            t.set(input.name, val);

            if (input.name === "material") {
              m(nameText, true);
              f(input);
              H(val);
            }

            if (input.name === "layout") {
              o = val;
              S(r);
            }

            if (input.name === "color") {
              r = val;
              S(val);
            }

            if (input.name === "dimension") {
              D = val ? `-${val}` : "";
              S(r);
            }

            v(input.name, val);
            Z(input.name);
          }
        });

        window.history.replaceState(
          {},
          "",
          decodeURIComponent(`${window.location.pathname}?${t}`),
        );
      }

      E();
    }

    let c = {};

    function d() {
      let t = Array.from(
        e.querySelectorAll(".product-configurator__fieldset--variants"),
        (fieldset) =>
          Array.from(fieldset.querySelectorAll("input")).find(
            (input) => input.checked,
          )?.value,
      );

      c = window.configProduct.variants.find(
        (variant) => !variant.options.map((option, o) => t[o] === option).includes(false),
      );

      if (c?.id) {
        y("variant", c.id);
      }

      C();
    }

    function k() {
      const t = document.querySelector('product-info > div[id*="price-"]'),
        o = e.querySelector(".product-configurator__box__right__price");

      t && o && (o.innerHTML = t.outerHTML);
    }

    function T() {
      const t = e.querySelector(".product-configurator__box__right__right-box"),
        o = document.querySelector(".product-form__quantity .wishlist_icon"),
        r = document.querySelector(".product-form__quantity quantity-input"),
        n = r?.querySelector(".quantity__input"),
        a = document.querySelector(
          '.product-form__buy-buttons [type="submit"]',
        );

      t && o && (t.innerHTML += o.outerHTML);
      t && r && (t.innerHTML += r.outerHTML);
      t && a && (t.innerHTML += a.outerHTML);

      const c = e.querySelector(
          ".product-configurator__box__right__right-box .wishlist_icon",
        ),
        i = e.querySelector(
          ".product-configurator__box__right__right-box .quantity__input",
        ),
        l = e.querySelector(
          '.product-configurator__box__right__right-box [type="submit"]',
        );

      c &&
        c.addEventListener("click", () => {
          o.click();
        });

      i &&
        (i.removeAttribute("id"),
        i.removeAttribute("form"),
        i.addEventListener("change", () => {
          const e = i.value;
          e && n && (n.value = e);
        }));

      l &&
        (l.removeAttribute("id"),
        l.removeAttribute("type"),
        (l.style.width = a.offsetWidth + "px"),
        l.addEventListener("click", () => {
          l.classList.add("loading");

          const e = l.querySelector(".loading__spinner");

          e && e.classList.remove("hidden");

          a.click();

          setTimeout(() => {
            C();
          }, 1000);

          setTimeout(() => {
            const e = new CartNotification();
            e && e.open();
          }, 2000);

          setTimeout(() => {
            l.classList.remove("loading");

            const e = l.querySelector(".loading__spinner");
            e && e.classList.add("hidden");
          }, 3000);
        }),
        window.addEventListener("resize", () => {
          l.style.width = a.offsetWidth + "px";
        }));
    }

    function C() {
      const t = e.querySelector(
        ".product-configurator__box__right__right-box .quantity__input",
      );

      t && (t.value = 1);
    }

    function W() {
      const t = e.querySelectorAll(
        ".product-configurator__fieldset--variants input:checked",
      );

      let n = null;

      t.forEach((e) => {
        const t = e.closest(".product-configurator__fieldset--variants"),
          o = t?.dataset?.option?.toLowerCase()?.replace(/^_/, "");

        if (
          [
            "szerokość",
            "width",
            "dimension",
            "sirka",
            "šířka",
            "rozmer",
            "rozměr",
            "breite",
          ].includes(o)
        ) {
          n = e.value;
        }
      });

      D = n ? `-${n}` : "";

      n && y("dimension", n);

      S(r);
    }

    const _fallback = setTimeout(() => {
      document.body.classList.add("digi-variant-ready");
      document.body.classList.add("digi-price-ready");
      document.body.classList.add("digi-gallery-ready");
    }, 3000);

    window.addEventListener(
      "digi:variant-ready",
      () => {
        clearTimeout(_fallback);
      },
      { once: true },
    );

    Q();
    d();
    k();
    T();

    let i = null;

    const l = e.querySelector(".conditional-logic");

    l && (i = JSON.parse(l.textContent));

    const u = e.querySelectorAll(
      ".product-configurator__fieldset--variants input",
    );

    u.length &&
      u.forEach((e) => {
        e.checked && b(e.value);

        const t = e.closest(".product-configurator__fieldset--variants"),
          n = t?.dataset?.option?.toLowerCase()?.replace(/^_/, "");

        const isDimension = [
          "szerokość",
          "width",
          "dimension",
          "sirka",
          "šířka",
          "rozmer",
          "rozměr",
          "breite",
        ].includes(n);

        e.checked &&
          isDimension &&
          ((D = e.value ? `-${e.value}` : ""),
          y("dimension", e.value || ""),
          S(r));

        e.addEventListener("change", () => {
          d();
          v(e.name, e.value);
          A(e.value);
          b(e.value);

          const t = e.closest(".product-configurator__fieldset--variants"),
            n = t?.dataset?.option?.toLowerCase()?.replace(/^_/, "");

          const isDimensionInner = [
            "szerokość",
            "width",
            "dimension",
            "sirka",
            "šířka",
            "rozmer",
            "rozměr",
            "breite",
          ].includes(n);

          isDimensionInner &&
            ((D = e.value ? `-${e.value}` : ""),
            y("dimension", e.value || ""),
            S(r));
        });
      });

    const s = e.querySelectorAll(".product-configurator__fieldset--attr input");

    s.length &&
      s.forEach((e) => {
        let val = getVal(e);

        e.checked && b(val);
        e.checked && e.name !== "material" && e.name !== "color" && p(e);

        e.addEventListener("change", () => {
          val = getVal(e);

          y(e.name, val);
          v(e.name, val);
          Z(e.name);
          b(val);

          if (e.name === "layout") {
            o = val;
            S(r);
          }

          if (e.name === "dimension") {
            D = val ? `-${val}` : "";
            S(r);
          }

          e.name !== "material" && e.name !== "color" && p(e);
        });
      });

    const _ = e.querySelectorAll(
      ".product-configurator__fieldset--material input",
    );

    if (_) {
      const t = e.querySelectorAll(
        '.product-configurator__fieldset--variants[data-option="_Tkanina"] label',
      );

      t.length &&
        _.forEach((e) => {
          let val = getVal(e);

          e.checked &&
            (m(
              e.nextElementSibling.querySelector(".name").textContent.trim(),
              true,
            ),
            f(e),
            H(val));

          e.addEventListener("change", () => {
            val = getVal(e);

            Array.from(t)
              .find((t) => t.dataset.value == e.dataset.group)
              ?.click();

            m(
              e.nextElementSibling
                .querySelector(".name")
                .textContent.trim(),
            );

            f(e);
            H(val);
          });
        });
    }

    function m(t, o = false) {
      const r = e.querySelectorAll(
        ".product-configurator__fieldset--color input",
      );

      r.length &&
        r.forEach((e) => {
          e.dataset.group === t
            ? (o || ((o = true), e.nextElementSibling.click()),
              (e.nextElementSibling.style.display = "inline-flex"))
            : ((e.checked = false),
              e.removeAttribute("checked"),
              (e.nextElementSibling.style.display = "none"));
        });
    }

    function p(t) {
      let val = getVal(t);

      const o = e.querySelector(`.${t.name}-image[data-attr="${val}"]`),
        r = document.querySelector(
          `.product-configurator__accordion[data-type="${t.name}"] .product-configurator__details__image .image`,
        );

      o && r && (r.innerHTML = o.dataset.image);
    }

    function f(t) {
      let val = getVal(t);

      const o = e.querySelector(`.material-data[data-material="${val}"]`),
        r = e.querySelector(`.material-thumbnail[data-material="${val}"]`),
        n = e.querySelector(`.material-attrs[data-material="${val}"]`),
        a = e.querySelector(
          '.product-configurator__accordion[data-type="material"] .product-configurator__details__image .image',
        ),
        c = e.querySelector(
          '.product-configurator__accordion[data-type="material"] .product-configurator__details__text',
        );

      let i = {},
        l = "";

      if (o && n) {
        i = JSON.parse(o.textContent);

        let e = n.dataset.text;

        c.innerHTML = `<div class="s2">${i.name}</div><hr/><ul>${e}</ul>`;
      }

      r && ((l = r.dataset.image), (a.innerHTML = l));
    }

    const g = e.querySelectorAll(
      ".product-configurator__fieldset--color input",
    );

    function y(e, t) {
      const o = new URLSearchParams(window.location.search);

      o.set(e, t);

      window.history.replaceState(
        {},
        "",
        decodeURIComponent(`${window.location.pathname}?${o}`),
      );

      a = `${window.shopUrl}${window.location.pathname}?${o}`;

      const r = document.querySelectorAll('input[id*="ShareUrl"]');

      r.length &&
        r.forEach((e) => {
          e.value = a;
        });
    }

    function S(t) {
      const o = e.querySelectorAll(".product-configurator__image");

      o.length &&
        o.forEach((e) => {
          const o = e.dataset.title,
            r = e.querySelector("img");

          if (r && o) {
            let a = o.split("X"),
              c = a[0] + t + a[1],
              i = r.getAttribute("src"),
              l = r.getAttribute("srcset").split(", ");

            l.length &&
              l.forEach((e, t) => {
                let o = e.split(" ");

                o[0] = h(o[0], c);
                l[t] = o.join(" ");
              });

            r.setAttribute("src", h(i, c));
            r.setAttribute("srcset", l.join(", "));

            const u = e.querySelector(".image_zoom");

            u &&
              (n == 0 &&
                u.getAttribute("data-image") &&
                (n = u.getAttribute("data-image").split("width=")[1]),
              u.setAttribute(
                "data-image",
                h(i.replace("width=900", "width=" + n), c),
              ));
          }
        });
    }

    function h(e, t) {
      let r = e.split("/"),
        n = t + ".jpg" + r[r.length - 1].split(".jpg")[1];

      n = n
        .replace(/-(220|230|250)(?=\.jpg)/, "")
        .replace(/-lewa(?=\.jpg)/, "");

      D && (n = n.replace(/\.jpg/, `${D}.jpg`));

      o === "lewa" && (n = n.replace(/\.jpg/, "-lewa.jpg"));

      r[r.length - 1] = n;

      return r.join("/");
    }

    function v(t, o) {
      const r = findInput(t, o),
        n = e.querySelector(`.form__label[data-name=${t}] .selected`);

      n &&
        r?.nextElementSibling &&
        (n.textContent =
          r.nextElementSibling.querySelector(".name").textContent);

      E();
    }

    function b(t) {
      i?.length &&
        i.forEach((o) => {
          const r = findInput(o.trigger, t),
            n = e.querySelector(
              `.product-configurator__accordion[data-name="${o.target}"]`,
            );

          let rVal = r ? getVal(r) : t;

          r &&
            n &&
            (n.style.display = rVal == o.if_not_enabled ? "none" : "block");

          const a = e.querySelector(
            `.product-configurator__box__left__text span[data-name="${o.target}"]`,
          );

          r &&
            a &&
            (a.style.display = rVal == o.if_not_enabled ? "none" : "inline");

          const c = document.querySelector(
            `.product__params__param[data-name="${o.target}"]`,
          );

          r &&
            c &&
            (c.style.display = rVal == o.if_not_enabled ? "none" : "block");

          const i = document.querySelector(
            `input[name="properties[${o.target}]"]`,
          );

          r && i && (i.value = rVal == o.if_not_enabled ? "" : i.dataset.value);
        });
    }

    function x() {
      const e = document.querySelector(
          ".product-configurator__box__left__title",
        ),
        t = document.querySelector(".product-configurator__box__left__text");

      e &&
        t &&
        e.addEventListener("click", () => {
          e.classList.toggle("open");
          t.classList.toggle("open");
        });
    }

    function E() {
      const t = e.querySelector(".product-configurator__box__left__config"),
        o = e.querySelectorAll('.form__label:not([data-name="_tkanina"])');

      const checkedMattress = e.querySelector(
        '.product-configurator__fieldset--materac input:checked, ' +
          '.product-configurator__fieldset--matrace input:checked, ' +
          '.product-configurator__fieldset--matratze input:checked',
      );

      let isNoMattress = false;

      if (checkedMattress) {
        const mattressValue = (checkedMattress.value || "")
          .toString()
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-z0-9\-]+/g, "-")
          .replace(/-+/g, "-")
          .replace(/^-+|-+$/g, "");

        isNoMattress = [
          "brak-materaca",
          "bez-matrace",
          "keine-matratze",
        ].includes(mattressValue);
      }

      let r = "";

      if (t && o.length) {
        o.forEach((label) => {
          const txt = (label.textContent || "").trim().toLowerCase();

          const isHardnessLabel =
            txt.includes("twardość materaca") ||
            txt.includes("twardosc materaca") ||
            txt.includes("tvrdost matrace") ||
            txt.includes("matratzenhärte") ||
            txt.includes("matratzenharte");

          if (isNoMattress && isHardnessLabel) return;

          r += `<span data-name="${label.textContent
            .split(":")[0]
            .trim()}">${label.textContent}</span>`;
        });

        t.innerHTML = r;
      }

      let n = "";

      const a = document.querySelector("product-info > .product__params");

      const c = e.querySelectorAll(
        '.product-configurator__accordion:not([data-type="_tkanina"]):not([data-type="material"]) input[type=radio]:checked+label',
      );

      if (a && c.length) {
        c.forEach((label) => {
          const nameNode = label.querySelector(".name");
          const colorNode = label.querySelector(
            ".product-configurator__label__color",
          );

          const text = (nameNode?.textContent || "").trim().toLowerCase();
          const dataName = (nameNode?.dataset?.name || "")
            .trim()
            .toLowerCase();

          const isHardnessItem =
            text.includes("twardość materaca") ||
            text.includes("twardosc materaca") ||
            text.includes("tvrdost matrace") ||
            text.includes("matratzenhärte") ||
            text.includes("matratzenharte") ||
            dataName.includes("twardość materaca") ||
            dataName.includes("twardosc materaca") ||
            dataName.includes("tvrdost matrace") ||
            dataName.includes("matratzenhärte") ||
            dataName.includes("matratzenharte");

          if (isNoMattress && isHardnessItem) return;

          if (nameNode) {
            n += `<div class="product__params__param" data-name="${nameNode.dataset.name}">${colorNode ? colorNode.outerHTML : ""}${nameNode.textContent}</div>`;
          }
        });

        a.innerHTML = n;
      }
    }

    function Z(t) {
      const selectedNode = e.querySelector(
        `.form__label[data-name=${t}] .selected`,
      );

      const legend = e.querySelector(
        `.product-configurator__accordion--attr[data-type=${t}] legend`,
      );

      if (!legend) return;

      const legendText = legend.textContent.trim();

      const propertyInputs = document.querySelectorAll(
        `input[name="properties[${legendText}]"]`,
      );

      if (!propertyInputs.length) return;

      const isHardnessField = [
        "Twardość materaca",
        "Tvrdost matrace",
        "Matratzenhärte",
        "Matratzenharte",
      ].includes(legendText);

      const checkedMattress = document.querySelector(
        '.product-configurator__fieldset--materac input:checked, ' +
          '.product-configurator__fieldset--matrace input:checked, ' +
          '.product-configurator__fieldset--matratze input:checked',
      );

      let isNoMattress = false;

      if (checkedMattress) {
        const mattressValue = (checkedMattress.value || "")
          .toString()
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-z0-9\-]+/g, "-")
          .replace(/-+/g, "-")
          .replace(/^-+|-+$/g, "");

        isNoMattress = [
          "brak-materaca",
          "bez-matrace",
          "keine-matratze",
        ].includes(mattressValue);
      }

      if (isHardnessField && isNoMattress) {
        propertyInputs.forEach((input) => {
          input.value = "";
          input.dataset.value = "";
        });

        return;
      }

      const value = selectedNode ? selectedNode.textContent.trim() : "";

      propertyInputs.forEach((input) => {
        input.value = value;
        input.dataset.value = value;
      });
    }

    function A(e) {
      let input = findInput(null, e);

      let valToClick = e;

      if (input) {
        valToClick = input.value;
      }

      const t = document.querySelector(
        `variant-selects input[value="${valToClick}"]`,
      );

      t && t.nextElementSibling && t.nextElementSibling.click();
    }

    g.length &&
      g.forEach((e) => {
        e.addEventListener("change", () => {
          let val = getVal(e);

          r = val;
          S(val);
        });
      });

    x();

    const L = e.querySelectorAll('[id^="Accordion-"]'),
      w = e.querySelectorAll('[id^="Accordion-"] summary');

    w.length &&
      L.length &&
      w.forEach((e) => {
        e.addEventListener("click", (e) => {
          L.forEach((e) => {
            e.removeAttribute("open");
          });

          e.currentTarget.parentNode.setAttribute("open", "");
        });
      });

    t &&
      (function () {
        const o = t.querySelector(".product-popup-modal__toggle");

        o &&
          o.addEventListener("click", () => {
            document.body.classList.add("overflow-hidden");
          });

        const r = e.querySelectorAll(".button--zoom");

        r.length &&
          r.forEach((o) => {
            o.addEventListener("click", () => {
              M(o.dataset.value, o.dataset.type);
            });
          });
      })();

    function H(o) {
      t &&
        e.querySelector(
          '.product-configurator__accordion[data-type="material"] .button--zoom',
        ) &&
        (e.querySelector(
          '.product-configurator__accordion[data-type="material"] .button--zoom',
        ).dataset.value = o);
    }

    function M(o, r) {
      if (t) {
        let n = "",
          a = "";

        const c = e.querySelector(`.${r}-video[data-material="${o}"]`),
          i = e.querySelector(`.${r}-image[data-material="${o}"]`),
          l = t.querySelector(".product-configurator__material__video"),
          u = t.querySelector(".product-configurator__material__image");

        c && ((n = c.dataset.video), (l.innerHTML = n));
        i && ((a = i.dataset.image), (u.innerHTML = a));
      }
    }

    function j(t) {
      const o = e.querySelector(".product-configurator__right");

      if (o) {
        const e = t.closest(".accordion"),
          r = o.dataset.disableNextStep?.substring(1);

        if (e && r) {
          const t = e.dataset.name;

          r.split(";").includes(t) || N(U(e, ".accordion"));
        } else {
          N(U(e, ".accordion"));
        }
      }
    }

    function U(e, t) {
      if (!e) return;

      let o = e.nextElementSibling;

      for (; o; ) {
        if (o.matches(t)) return o;

        o = o.nextElementSibling;
      }
    }

    function N(e) {
      if (e) {
        const t = e.querySelector("summary");

        t && t.click();
      }
    }

    W();
  }
})();